module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback6-e6e4da3a8513a5c38e71291c2d4eeb67.jpg";